import React, { createContext, useContext, useState, useCallback } from 'react';

const CompareContext = createContext();

const MAX_COMPARE = 3;

export const CompareProvider = ({ children }) => {
  const [compareItems, setCompareItems] = useState([]);

  const addToCompare = useCallback((listing) => {
    setCompareItems(prev => {
      if (prev.length >= MAX_COMPARE) return prev;
      if (prev.some(item => item.id === listing.id)) return prev;
      // Only allow same category
      if (prev.length > 0 && prev[0].category !== listing.category) return prev;
      return [...prev, listing];
    });
  }, []);

  const removeFromCompare = useCallback((listingId) => {
    setCompareItems(prev => prev.filter(item => item.id !== listingId));
  }, []);

  const clearCompare = useCallback(() => {
    setCompareItems([]);
  }, []);

  const isInCompare = useCallback((listingId) => {
    return compareItems.some(item => item.id === listingId);
  }, [compareItems]);

  const canAdd = useCallback((listing) => {
    if (compareItems.length >= MAX_COMPARE) return false;
    if (compareItems.some(item => item.id === listing.id)) return false;
    if (compareItems.length > 0 && compareItems[0].category !== listing.category) return false;
    return true;
  }, [compareItems]);

  const categoryMismatch = useCallback((listing) => {
    return compareItems.length > 0 && compareItems[0].category !== listing.category;
  }, [compareItems]);

  return (
    <CompareContext.Provider value={{
      compareItems,
      addToCompare,
      removeFromCompare,
      clearCompare,
      isInCompare,
      canAdd,
      categoryMismatch,
      maxReached: compareItems.length >= MAX_COMPARE,
    }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) throw new Error('useCompare must be used within CompareProvider');
  return context;
};
